// Components==============
import { faList } from '@fortawesome/pro-solid-svg-icons';
import AddInput from 'components/UI/AddInput/AddInput';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import Modal from 'components/UI/Modal/Modal';
import { AnimatePresence } from 'framer-motion';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useState } from 'react';
import { MyPortfolioContext } from '../../MyPortfolio';
import './PortfolioSettings.module.scss';
import Row from './Row/Row';
// =========================

export default function PortfolioSettings() {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { portfolios, handleAddPortfolio } = useContext(MyPortfolioContext);

  const translate = useTranslate();

  return (
    <div styleName="portfolio-settings">
      <CircleButton
        icon={faList}
        color="grey-blue"
        onClick={() => setModalIsOpen(true)}
      />
      <AnimatePresence>
        {modalIsOpen && (
          <Modal size="small" setModalIsOpen={setModalIsOpen}>
            <div styleName="modal-content">
              <h1>{translate('portfolio.manage-portfolios-popup.title')}</h1>
              <p styleName="description">
                {translate('portfolio.manage-portfolios-popup.description')}
              </p>
              {portfolios?.map(
                (p) =>
                  !!p && <Row name={p?.name || ''} key={p?.id} id={p?.id} />
              )}
              <p styleName="secondary-title">
                {translate('portfolio.manage-portfolios-popup.extra-title')}
              </p>
              <AddInput
                onSubmit={(val) => handleAddPortfolio(val)}
                placeholder="Portfolio"
              />
            </div>
          </Modal>
        )}
      </AnimatePresence>
    </div>
  );
}
